import store from '@/store'
export function getPermissions(name) { 
    let permissions = store.state.user.permissions
    return permissions.some(ele => ele == name)
  }


